// firebaseAuth.js
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  signInWithCustomToken,
} from "firebase/auth";
import { useState, useEffect } from "react";
import { auth } from "../config/FirebaseConfig";
import { User } from "../types/user";
// import { User as FirebaseUser } from "../auth/FirebaseAuth";
import type { User as FirebaseUser } from "firebase/auth";
import { Org, Workspace } from "../types/org";
// Initialize Firebase Auth instance

// Function to log in the user with email and password
export const loginUser = async (email: any, password: any) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error: any) {
    console.error("Error logging in:", error.message);
    throw error; // Throw the error so it can be handled in the component
  }
};

export const logoutUser = async () => {
  try {
    console.warn("logoutUser");
    await signOut(auth); // Log out the user
  } catch (error: any) {
    console.error("Error logging out:", error.message);
    throw error; // Handle the error wherever this function is called
  }
};

// Custom hook to track auth state
export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState<FirebaseUser | null>(null);
  const [loading, setLoading] = useState(true); // Loading indicator

  useEffect(() => {
    // Set up the listener - this will immediately fire with current auth state
    const unsubscribe = onAuthStateChanged(auth, (user: any) => {
      setCurrentUser(user);
      setLoading(false); // Loading finished after first auth state check
    });

    // Clean up the listener when the component unmounts
    return unsubscribe;
  }, []);

  return { currentUser, loading };
};

export async function signInAsGuest(token: any) {
  try {
    const userCredential = await signInWithCustomToken(auth, token);
  } catch (error) {
    console.error("Guest sign-in failed:", error);
  }
}
